import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type OtSelectOption } from '@1trading/design-system';
import { useVuelidate } from '@vuelidate/core';
import { required as requiredValidator } from '@vuelidate/validators';
import { computed, reactive, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'XSelectMulti',
  props: {
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: true },
  value: { type: Array as PropType<Array<OtSelectOption>>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const dummyCheck = () => true;
const validationRules = {
  internalVModel: { required: props.required ? requiredValidator : dummyCheck },
};

const v = useVuelidate(validationRules, reactive({ internalVModel: props.value }));
const validationErrorMessages = computed(() => ({
  internalVModel: {
    required: t('fundamentals.multiSelect.required'),
  },
}));

return (_ctx: any,_cache: any) => {
  const _component_ot_select = _resolveComponent("ot-select")!
  const _component_ot_input_error_wrapper = _resolveComponent("ot-input-error-wrapper")!

  return (_openBlock(), _createBlock(_component_ot_input_error_wrapper, {
    error: _unref(v).internalVModel,
    "error-messages": validationErrorMessages.value.internalVModel,
    disabled: __props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ot_select, _mergeProps(_ctx.$attrs, {
        value: _unref(v).internalVModel.$model,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v).internalVModel.$model) = $event)),
        class: "x-select-multi",
        disabled: __props.disabled,
        multiple: true
      }), null, 16, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["error", "error-messages", "disabled"]))
}
}

})